import { render, staticRenderFns } from "./EditSaleAccountModal.vue?vue&type=template&id=24498fe7&scoped=true"
import script from "./EditSaleAccountModal.vue?vue&type=script&lang=ts"
export * from "./EditSaleAccountModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24498fe7",
  null
  
)

export default component.exports